<template>
  <el-card shadow="hover">
    页面模版
  </el-card>
</template>

<script>
export default {
  name: 'template',
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// src/page/Template.vue